var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal","appear":""}},[_c('div',{staticClass:"modal-window"},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }